import Firma from '@/components/Firma.vue';
import mixGenerarPdf from '@/helpers/mixGenerarPdf';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'MainReporteEstimacionesRelacionConceptos',
  components: {
    Firma,
  },
  mixins: [mixGenerarPdf, mixFormatoEstructura],
  /*
  props: {
    estimacion: {
      type: Object,
      required: true,
    },
    contrato: {
      type: Object,
      required: true,
    },
    firmas: {
      type: Array,
      required: false,
    },
  },
  */
  data() {
    return {};
  },
  methods: {
    sumaImporteContratado(estimado) {
      const importes = estimado.map((est) => ({
        importe: est.concepto.importe,
      }));
      return this.$ObjSumar(importes, 'importe');
    },
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto);
    },
    async generarPdfRelacionConceptos() {
      this.$emit('generando');
      let contrato = {
        numero: this.contrato.numero,
        objeto: this.contrato.meta,
        contratista: this.contrato.contratista,
        fecha: this.contrato.fecha,
        fechaInicio: this.contrato.fechaInicio,
        fechaTermino: this.contrato.fechaTermino,
        importe: this.contrato.importe,
      };
      let estimacion = {
        numero: this.estimacion.numero,
        fechaDel: this.estimacion.fechaDel,
        fechaAl: this.estimacion.fechaAl,
        fechaPresentacion: this.estimacion.fechaPresentacion,
        fechaAutorizacion: this.estimacion.fechaAutorizacion,

      };
      const tituloTotales = this.contrato.esObraFinanciada ? 'IMPORTE COSTO DIRECTO' : 'IMPORTE ESTIMADO';
      let totales = {
        tituloTotales,
        sumaTotalContratado: this.sumaTotalContratado.importe,
        sumaTotalEstimadoAnterior: this.sumaTotalEstimadoAnteriror.importe,
        sumaTotalEstimadoActual: this.sumaTotalEstimadoActual.importe,
        sumaTotalAcumulado: this.sumaTotalEstimadoAnteriror.importe
                            + this.sumaTotalEstimadoActual.importe,
      };
      let partidas = this.getPartidas;
      const partidasSubtotal = partidas.map((partida) => {
        const subtotalImporteContratado = this.sumaImporteContratado(partida.conceptosEstimados);
        const subtotalImporteEstimadoAnterior = this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior');
        const subtotalImporte = this.$ObjSumar(partida.conceptosEstimados, 'importe');
        const subtotalImporteAcumulado = this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior')
                    + this.$ObjSumar(partida.conceptosEstimados, 'importe');
        return {
          partida,
          subtotalImporteContratado,
          subtotalImporteEstimadoAnterior,
          subtotalImporte,
          subtotalImporteAcumulado,
        };
      });

      partidas = this.formatoObjeto(partidasSubtotal);
      estimacion = this.formatoObjeto(estimacion);
      contrato = this.formatoObjeto(contrato);
      const supervisor = this.getSupervisor || '';
      const supervisionExterna = this.getContratoSupervisionExterna?.contratoRelacionado
        ?.contratista?.nombreRazonSocial || '';
      const firmasFuncionarios = this.firmas;
      const fechaActual = this.formatoFechaActual();
      totales = this.formatoObjeto(totales);

      const cliente = this.getCliente || { logo: '', nombre: '' };

      const nombreTemplate = 'templateRelacionConceptos';

      await this.mixGenerarPdf({
        configuracion: {
          path: 'wepp/wep',
          PUPPETEER_CONFIGURACION: {
            landscape: true,
            format: 'A3',
          },
          nombreTemplate,
        },
        data: {
          contrato,
          estimacion,
          partidas,
          supervisor,
          supervisionExterna,
          firmas: firmasFuncionarios,
          fechaActual,
          totales,
          cliente,
          footer: '',
        },
      }, `${this.contrato.numero}_RelacionConceptos_Estimacion_${this.estimacion.numero}`);
      this.$emit('terminando');
    },
  },
  computed: {
    getPartidas() {
      // Formato de conceptos
      const partidas = this.estimacion.conceptos
        .filter(({ cantidad }) => cantidad !== 0)
        .map(({ concepto: { padre }, concepto }) => {
          let partida = null;
          if (padre.padre && padre.padre.tipo === 0) {
            partida = padre.padre;
          }
          return {
            id: padre.id,
            clave: padre.clave.slice(0, 15),
            concepto: padre.concepto,
            orden: concepto.orden,
            padre: partida,
            tipo: padre.tipo,
            conceptosEstimados: [],
          };
        });

      // Remover conceptos repetidos
      const partidasUnicas = [...new Map(partidas.map((v) => [v.id, v])).values()];

      return partidasUnicas.map((partida) => {
        const conceptos = this.estimacion.conceptos
          .filter(({ cantidad }) => cantidad !== 0)
          .filter(({ concepto: { padre } }) => padre.id === partida.id)
          .map((concepto) => {
            const { estimado } = concepto.concepto;
            const estimadoAnterior = estimado
              .map((con) => ({
                numero: con.estimacion.numero,
                cantidad: con.cantidad,
                importe: con.importe,
              }))
              .filter(({ numero }) => numero < this.estimacion.numero);

            return {
              ...concepto,
              cantidadEstimadaAnterior: this.$ObjSumar(estimadoAnterior, 'cantidad'),
              importeEstimadoAnterior: this.$ObjSumar(estimadoAnterior, 'importe'),
              cantidadEstimadaAcumulada: this.$ObjSumar(estimadoAnterior, 'cantidad') + concepto.cantidad,
              importeEstimadoAcumulado: this.$ObjSumar(estimadoAnterior, 'importe') + concepto.importe,
            };
          })
          .sort((a, b) => a.concepto.orden - b.concepto.orden);

        return {
          ...partida,
          conceptosEstimados: conceptos,
        };
      })
        .sort((a, b) => a.orden - b.orden);
    },
    sumaTotalContratado() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        const estimado = partida.conceptosEstimados;
        const importes = estimado.map((est) => ({
          importe: est.concepto.importe,
        }));

        suma.push({
          importe: this.$ObjSumar(importes, 'importe'),
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    sumaTotalEstimadoAnteriror() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        suma.push({
          importe: this.$ObjSumar(partida.conceptosEstimados, 'importeEstimadoAnterior'),
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    sumaTotalEstimadoActual() {
      const suma = [];
      if (this.getPartidas.length <= 0) return {};

      this.getPartidas.forEach((partida) => {
        suma.push({
          importe: this.$ObjSumar(partida.conceptosEstimados, 'importe'),
        });
      });

      const importe = this.$ObjSumar(suma, 'importe');
      const iva = this.$numberRound((importe * (this.contrato.porcetajeIva)));
      const total = this.$numberRound((importe + iva));

      return {
        importe,
        iva,
        total,
      };
    },
    getSupervisor() {
      if (!this.contrato) return null;
      if (!this.contrato.responsables) return null;
      return this.contrato.responsables.find((responsable) => responsable.principal === true);
    },
    getContratoSupervisionExterna() {
      return this.contrato.contratosRelacionados
        .find(({ esSupervisionExterna }) => esSupervisionExterna === true);
    },
    getCliente() {
      if (!this.contrato.cliente) return { logo: '', nombre: '' };
      return this.contrato.cliente;
    },
  },
};
